import { slicedToArray as _slicedToArray } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import { useTheme } from 'styled-components';
import useRect from '../../../../hooks/useRect.js';
import { OPEN_END_SIZE_TOKENS, OPEN_ENDS } from '../constants.js';

var ensureValidValues = function ensureValidValues(values, _ref) {
  var max = _ref.max,
    min = _ref.min;
  if (!Array.isArray(values)) return values;
  var _values = _slicedToArray(values, 2),
    minValue = _values[0],
    maxValue = _values[1];
  return [minValue < min ? undefined : Math.min(minValue, max), maxValue > max ? undefined : Math.max(maxValue, min)];
};
function useSliderOpenEnds(_ref2) {
  var max = _ref2.max,
    min = _ref2.min,
    openEnds = _ref2.openEnds,
    step = _ref2.step;
  var _useRect = useRect(undefined, [max, min, openEnds, step]),
    _useRect2 = _slicedToArray(_useRect, 2),
    ref = _useRect2[0],
    width = _useRect2[1].width;
  var theme = useTheme();
  var openEndsWidthInPx = theme.remToPx(OPEN_END_SIZE_TOKENS.GAP) + theme.remToPx(OPEN_END_SIZE_TOKENS.WIDTH);
  var openEndMax = openEnds === OPEN_ENDS.BOTH || openEnds === OPEN_ENDS.MAX;
  var openEndMin = openEnds === OPEN_ENDS.BOTH || openEnds === OPEN_ENDS.MIN;
  var numberOfValidValues = Math.round((max - min + 1) / step);
  var valueWidthInPx = width / numberOfValidValues || 1;
  var valuesToAddForOpenEndSpacing = Math.ceil(openEndsWidthInPx / valueWidthInPx) * step;
  var newMax = openEndMax ? max + valuesToAddForOpenEndSpacing : max;
  var newMin = openEndMin ? min - valuesToAddForOpenEndSpacing : min;
  var createChangeHandler = function createChangeHandler(callback) {
    return function (event, value) {
      return callback(event, ensureValidValues(value, {
        max: max,
        min: min
      }));
    };
  };
  return [ref, {
    createChangeHandler: createChangeHandler,
    max: newMax,
    min: newMin
  }];
}

export { useSliderOpenEnds as default };
//# sourceMappingURL=useSliderOpenEnds.js.map
